import React, { useState } from 'react';
import {
  ResponsiveContainer, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip,
} from 'recharts';
import { useTranslation } from 'react-i18next';
import Icon from '../../components/Icon';
import StatDropdown from './StatDropdown';
import ChartTooltip from './ChartTooltip';
import { useChartPalette } from '../useThemeMode';
import { SALES_PERFORMANCE, SALES_PERIODS } from '../mockData';

const POINTS_BY_PERIOD = { '12m': 12, '6m': 6, '30d': 4 };

const SalesPerformance = () => {
  const { t } = useTranslation();
  const palette = useChartPalette();
  const [period, setPeriod] = useState('12m');

  const data = SALES_PERFORMANCE.slice(-(POINTS_BY_PERIOD[period] || 12));

  return (
    <section className="stats-card stats-chart-card">
      <header className="stats-card-head">
        <div>
          <h3 className="stats-card-title">{t('statistics.sales.title')}</h3>
          <p className="stats-card-subtitle">{t('statistics.sales.subtitle')}</p>
        </div>
        <div className="stats-card-actions">
          <StatDropdown value={period} options={SALES_PERIODS} onChange={setPeriod} />
          <button type="button" className="stats-btn">
            <Icon name="upload" size={14} />
            {t('statistics.export')}
          </button>
        </div>
      </header>

      <div className="stats-chart" style={{ height: 320 }}>
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data} margin={{ top: 10, right: 8, left: 0, bottom: 0 }}>
            <defs>
              <linearGradient id="statsSalesFill" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor={palette.line} stopOpacity={0.28} />
                <stop offset="100%" stopColor={palette.line} stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="4 4" stroke={palette.grid} vertical={false} />
            <XAxis
              dataKey="month"
              tickLine={false}
              axisLine={false}
              tick={{ fill: palette.axis, fontSize: 12 }}
              dy={8}
            />
            <YAxis
              tickLine={false}
              axisLine={false}
              tick={{ fill: palette.axis, fontSize: 12 }}
              tickFormatter={(v) => `${(v / 1000).toFixed(0)}K`}
              width={48}
            />
            <Tooltip
              cursor={{ stroke: palette.grid }}
              content={<ChartTooltip formatter={(v) => `${Number(v).toLocaleString('ru-RU')} MDL`} />}
            />
            <Area
              type="monotone"
              dataKey="sales"
              name={t('statistics.sales.sales')}
              stroke={palette.line}
              strokeWidth={2}
              fill="url(#statsSalesFill)"
            />
            <Area
              type="monotone"
              dataKey="target"
              name={t('statistics.sales.target')}
              stroke={palette.lineSoft}
              strokeWidth={1.5}
              strokeDasharray="6 4"
              fill="none"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </section>
  );
};

export default SalesPerformance;
